import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { NgxPageScrollModule } from 'ngx-page-scroll';
import { FlashMessagesService } from './flash-messages/service/flash.messages.service';
import { FieldValidationComponent } from './field/field-validation/field-validation.component';
import { InputComponent } from './field/input/input.component';
import { FlashMessagesComponent } from './flash-messages/component/flash-messages.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { DropdownComponent } from './field/dropdown/dropdown.component';
import { CustomerNumComponent } from './field/customer-num/customer-num.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule,
    NgxPageScrollModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  declarations: [
    FieldValidationComponent,
    FlashMessagesComponent,
    InputComponent,
    CustomerNumComponent,
    SpinnerComponent,
    DropdownComponent
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule,
    TranslateModule,
    NgxPageScrollModule,
    FieldValidationComponent,
    FlashMessagesComponent,
    InputComponent,
    CustomerNumComponent,
    SpinnerComponent,
    TranslateModule,
    DropdownComponent
  ],
  providers: [
    FlashMessagesService
  ]
})
export class SharedModule { }

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
